import React, {Component} from 'react';
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap";

class DropDownList extends Component {
  constructor(props) {
    super(props);
    
    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false,
      headerTitle: this.props.title
    };
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  handleSelected(item = null) {
    this.setState({selected : item});
    this.props.onSelectedChanged(item);
  }

  get itemName() {
    if (this.state.selected) {
      return this.state.selected.propertyName;
    } else if (this.props.selected) {
      return this.props.selected.propertyName;
    }
    return this.state.headerTitle;
  }

  render() {
    const renderItems = this.props.items.map(item => {
      return <DropdownItem key={item.id} onClick={() => this.handleSelected(item)}>{item.propertyName}</DropdownItem>
    });

    return (
      <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} style={{ minWidth: '150px' }}>
        <DropdownToggle caret>{this.itemName}</DropdownToggle>
        <DropdownMenu>
          <DropdownItem key="" onClick={() => this.handleSelected()}>{this.state.headerTitle}</DropdownItem>
          {renderItems}
        </DropdownMenu>
      </ButtonDropdown>
    );
  }
}

DropDownList.defaultProps = {
  title: 'Select',
  items: [],
  selected: null,
  onSelectedChanged: (property) => {},
};

export default DropDownList;


// WEBPACK FOOTER //
// ./src/components/DropDownList/DropDownList.js